export class AgGridDetailRow {
    isDetailRow = true;
    hidden: boolean;

    static isDetailRow(row: any) {
        return typeof (row as AgGridDetailRow).isDetailRow !== 'undefined'
    }
}
